import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import Button from 'components/button/Button';
import FormWithProvider from 'components/forms/form/Form';
import Loader from 'components/loader/Loader';
import { FormFooterStyled } from '../DirectBookingEngine.styles';
import useFetchDbsSettings from '../useFetchDbsSettings';
import {
  getFormDefaultValues,
  getWebsiteSettingsSchema,
} from './WebsiteSettingsTab.schema';
import SiteAccessSection from './siteAccess/SiteAccessSection';
import TrackingSettingsSection from './sections/TrackingSettingsSection';
import WebsiteSettingsSection from './sections/WebsiteSettingsSection';
import WidgetSettingsSection from './sections/WidgetSettingsSection';
import useFetchSelectablePropertyOptions from './useFetchSelectablePropertyOptions';
import useWebsiteSettingsFormSubmit from './useWebsiteSettingsFormSubmit';

const WebsiteSettingsTab = () => {
  const { t } = useTranslation();
  const { dbsSettings, isLoading, isError } = useFetchDbsSettings();
  const {
    propertyOptions,
    isLoading: isLoadingProperties,
    isError: isPropertiesError,
  } = useFetchSelectablePropertyOptions();
  const handleSubmit = useWebsiteSettingsFormSubmit(dbsSettings);

  if (isLoading || isLoadingProperties) {
    return <Loader />;
  }

  if (isError || isPropertiesError) {
    return (
      <div data-testid="direct-booking-engine-website-settings-error">
        {t('common.somethingWentWrong')}
      </div>
    );
  }

  return (
    <>
      <SiteAccessSection />
      <FormWithProvider
        data-testid="direct-booking-engine-website-settings"
        defaultValues={getFormDefaultValues(
          dbsSettings,
          propertyOptions.filter(({ disabled }) => !disabled),
        )}
        onSubmit={handleSubmit}
        schema={getWebsiteSettingsSchema(t)}
      >
        <WebsiteSettingsSection
          heroUrl={dbsSettings?.heroUrl}
          propertyOptions={propertyOptions}
        />
        <WidgetSettingsSection />
        <TrackingSettingsSection />
        <FormFooterStyled>
          <Button
            bsStyle="primary"
            data-testid="save-website-settings-button"
            type="submit"
          >
            {t('pageDirectBookingEngine.websiteSettings.save')}
          </Button>
        </FormFooterStyled>
      </FormWithProvider>
      <Outlet />
    </>
  );
};

export default WebsiteSettingsTab;
